export const getFileFromUrl = async (url: string, name: string) => {
    if (url && name) {
        const logoBlob = await fetch(url).then(d => d.blob());
        return new File([logoBlob], name);
    }
    return "";
};
